(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfaff-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'pfaff-intro-seen';

    const initialize = (intro) => {
      if (intro.dataset.initialized === 'true') return;
      intro.dataset.initialized = 'true';

      const video = intro.querySelector('[data-pfaff-intro-video]');
      const skip = intro.querySelector('[data-pfaff-intro-skip]');
      const sound = intro.querySelector('[data-pfaff-intro-sound]');
      const replay = document.querySelector(`[data-pfaff-intro-replay="${intro.id}"]`);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      let closeTimer;
      let seen = false;

      try {
        seen = localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        seen = false;
      }

      const close = () => {
        window.clearTimeout(closeTimer);
        video.pause();
        intro.hidden = true;
        document.body.classList.remove('pfaff-intro-open');
        try {
          localStorage.setItem(storageKey, 'true');
        } catch (error) {
          return;
        }
      };

      const mobile = window.matchMedia('(max-width: 749px)').matches;
      video.src = mobile ? intro.dataset.mobileSrc : intro.dataset.desktopSrc;
      video.defaultMuted = true;

      const open = () => {
        window.clearTimeout(closeTimer);
        video.currentTime = 0;
        video.muted = true;
        sound.textContent = sound.dataset.soundOn;
        sound.setAttribute('aria-pressed', 'false');
        intro.hidden = false;
        document.body.classList.add('pfaff-intro-open');
        skip.focus({ preventScroll: true });

        const playback = video.play();
        if (playback) playback.catch(close);
        closeTimer = window.setTimeout(close, 30000);
      };

      skip.addEventListener('click', close);
      replay?.addEventListener('click', open);
      video.addEventListener('ended', close);
      video.addEventListener('error', close);

      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        sound.textContent = video.muted ? sound.dataset.soundOn : sound.dataset.soundOff;
        sound.setAttribute('aria-pressed', String(!video.muted));
        if (video.paused) video.play().catch(close);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !intro.hidden) close();
      });

      if (!reducedMotion && (designMode || intro.dataset.showOnce !== 'true' || !seen)) {
        open();
      }
    };

    const start = () => {
      document.querySelectorAll('[data-pfaff-intro]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
